import Button from '../../../components/ui/Button';

import { SocialProvider } from '../types';

interface SocialLoginProps {
  onSocialLogin: (provider: string) => void;
  isLoading: boolean;
}

const SOCIAL_PROVIDERS: SocialProvider[] = [
  {
    id: 'google',
    name: 'Google',
    icon: 'Chrome',
    color: '#4285F4'
  },
  {
    id: 'facebook',
    name: 'Facebook',
    icon: 'Facebook',
    color: '#1877F2'
  }
];

const SocialLogin = ({ onSocialLogin, isLoading }: SocialLoginProps) => {
  return (
    <div className="space-y-4">
      <div className="relative">
        <div className="absolute inset-0 flex items-center">
          <div className="w-full border-t border-border"></div>
        </div>
        <div className="relative flex justify-center text-sm">
          <span className="px-4 bg-card text-muted-foreground">Or continue with</span>
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        {SOCIAL_PROVIDERS.map((provider) => (
          <Button
            key={provider.id}
            type="button"
            variant="outline"
            size="lg"
            onClick={() => onSocialLogin(provider.id)}
            disabled={isLoading}
            iconName={provider.icon}
            iconPosition="left"
            className="w-full"
          >
            {provider.name}
          </Button>
        ))}
      </div>
    </div>
  );
};

export default SocialLogin;